import {useEffect, useRef} from "react";
import {useRexAI} from "../../context/RexAIProvider";
import {isEmpty} from "underscore";

const EMPTY_ALLOWED_UI_FORM_FIELDS = [];
const EMPTY_ALLOWED_LIST_TOOLS = [];
export const DEFAULT_CONTEXT_ACCESS = "standard";
export const LOCATION_ONLY_CONTEXT_ACCESS = "location-only";
export const DEFAULT_CONTEXT_CAPTION = "Maestro has context of this page";
export const DEFAULT_CONTEXT_TOOLTIP = "Maestro can see you are viewing:";

export const buildUpdatedPageContext = ({
  pageType, toolMode, scopeContext, allowedUiFormFields, allowedListTools, availableTabs,
}) => ({
  pageType,
  toolMode,
  scopeContext,
  allowedUiFormFields: allowedUiFormFields || [],
  allowedListTools: allowedListTools || [],
  availableTabs: availableTabs || [],
});

export const useAgentPage = ({
  enabled = true,
  pageType,
  toolMode,
  allowedUiFormFields,
  allowedListTools,
  scopeContext,
  onWrite,
  addFormLabel,
  contextAccess = DEFAULT_CONTEXT_ACCESS,
  contextCaption = DEFAULT_CONTEXT_CAPTION,
  contextTooltip = DEFAULT_CONTEXT_TOOLTIP,
}) => {
  const {registerAgentPage, updateAgentPage, unregisterAgentPage} = useRexAI();
  const isLocationOnly = contextAccess === LOCATION_ONLY_CONTEXT_ACCESS;
  // Location-only pages may identify where the user is, but must not expose page-owned UI
  // capabilities or write callbacks to Maestro. Backend tools still remain available.
  const formFields =
    !isLocationOnly && !isEmpty(allowedUiFormFields) ?
      allowedUiFormFields :
      EMPTY_ALLOWED_UI_FORM_FIELDS;
  const listTools =
    !isLocationOnly && !isEmpty(allowedListTools) ? allowedListTools : EMPTY_ALLOWED_LIST_TOOLS;
  const pageOnWrite = isLocationOnly ? undefined : onWrite;
  const registrationId = useRef(Symbol("agent-page"));
  const pageRef = useRef();

  pageRef.current = {
    pageType,
    toolMode,
    allowedUiFormFields: formFields,
    allowedListTools: listTools,
    scopeContext,
    onWrite: pageOnWrite,
    addFormLabel,
    contextAccess,
    contextCaption,
    contextTooltip,
  };

  useEffect(() => {
    if (!enabled || !pageType) {
      return;
    }
    const id = registrationId.current;
    registerAgentPage(id, pageRef.current);
    return () => unregisterAgentPage(id);
  }, [enabled, pageType, registerAgentPage, unregisterAgentPage]);

  useEffect(() => {
    if (!enabled || !pageType) {
      return;
    }
    updateAgentPage(registrationId.current, pageRef.current);
  }, [
    enabled,
    pageType,
    toolMode,
    formFields,
    listTools,
    scopeContext,
    pageOnWrite,
    addFormLabel,
    contextAccess,
    contextCaption,
    contextTooltip,
    updateAgentPage,
  ]);
};
